<div class="agenda-card p-3 p-md-4">

  <div class="month-scroll">
    <div class="month-grid">
    <div class="month-head fs-xsmall fw-800 color-gray-400 text-center" *ngFor="let label of ['PZT','SAL','ÇAR','PER','CUM','CTS','PAZ']">
      {{label}}
    </div>

    <ng-container *ngFor="let week of weeks">
      <a
        class="month-cell p-2 clickable" *ngFor="let day of week"
        [class.other-month]="!day.isCurrentMonth" [class.today]="day.isToday"
        (click)="daySelected.emit(day.date)">

        <div class="d-flex align-items-center justify-content-between mb-1">
          <span class="fs-small fw-800 color-gray-950">{{day.date.format('D')}}</span>
          <span class="today-badge fs-xsmall fw-800" *ngIf="day.isToday">{{'agenda.today_badge'|translate}}</span>
        </div>

        <div class="month-item level-{{levelKey(item)}} fs-xsmall fw-500 px-2 py-1 mb-1"
             *ngFor="let item of day.appointments">
          {{item.startsAt|date:'HH:mm'}} · {{initials(item.student?.name)}}
        </div>
      </a>
      </ng-container>
    </div>
  </div>

  <p class="fs-xsmall fw-400 color-gray-400 mt-3 mb-0">{{'agenda.month_hint'|translate}}</p>
</div>
